import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchTeams = async (pageNumber, pageSize, searchTerm) => {
  return await axios.get(
    API_URL +
      `/api/Settings/GetTeams/${pageSize}/${pageNumber}${
        !isEmpty(searchTerm) ? `?Search=${searchTerm}` : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchTeamById = async (id) => {
  return await axios.get(API_URL + `/api/Settings/GetTeamsById/${id}`, {
    headers: securityHeaders,
  });
};

const deleteFacultyMember = (id) => {
  return axios.post(
    API_URL + `/api/Settings/DeleteTeams/${id}`,

    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchTeams = (pageNumber, pageSize, searchTerm) => {
  return useQuery({
    queryKey: ["teams"],
    queryFn: () => fetchTeams(pageNumber, pageSize, searchTerm),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useFetchTeamById = (id) => {
  return useQuery({
    queryKey: [`facultyMember-${id}`],
    queryFn: () => fetchTeamById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteFacultyMember = (id) => {
  return useMutation(() => deleteFacultyMember(id));
};
